import ApiService, {callCustomMethodAsync}  from '../service/ApiService';

let moduleApi = {};
let moduleName = "feature";

function getHeaders() {
  const token = localStorage.getItem(`mushroom.tokens[${window.MyConfig.hostApi}]`);
  return {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Token": token
  };
}

moduleApi.CreateFeatureCode = async (dataForm) => {
  const url = `${window.MyConfig.hostApi}features/CreateFeatureCode`;
  const response = await fetch(url, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(dataForm)
  });
  const result = await response.json();
  if (!response.ok || (result.code !== undefined && result.code < 0)) {
    throw result;
  }
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetAllFeaturesByUser = () => {
    let api = {
        module: moduleName,
        type: "GetAllFeaturesByUser",
        message: {
          success: "hidden",
          error: "hidden",
        }
    };
    return callCustomMethodAsync(api);
};

moduleApi.GetAllFeaturesByCompany = () => {
    let api = {
        module: moduleName,
        type: "GetAllFeaturesByCompany",
        message: {
          success: "hidden",
          error: "hidden",
        }
    };
    return callCustomMethodAsync(api);
};

export default moduleApi;
